import { Box, Popover, Card } from "@mui/material";
import ActiveFilters from "../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterAnchorEl,
  onCloseFilter,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  drivers,
  activeTab,
  orderStatuses = [],
  shiftModes = [],
}) => {
  const getDriverName = (driverId) => {
    if (!driverId) return "";
    const driver = drivers.find((d) => d.driver_id === driverId);
    return driver ? driver.full_name : driverId;
  };

  const getStatusName = (statusCode) => {
    if (!statusCode) return "";
    const status = orderStatuses.find((s) => s.code === statusCode);
    return status ? status.name : statusCode;
  };

  const getShiftName = (shiftValue) => {
    if (!shiftValue) return "";
    const shift = shiftModes.find((s) => s.code === shiftValue);
    return shift ? shift.code : shiftValue;
  };

  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "invoiceNumber",
      label: "Invoice No",
      value: submittedData.invoiceNumber,
    },
    {
      type: "standard",
      id: "jobId",
      label: "Job No",
      value: submittedData.jobId,
    },
    {
      type: "standard",
      id: "customerCode",
      label: "Customer Code",
      value: submittedData.customerCode,
    },
    {
      type: "standard",
      id: "driverId",
      label: "Driver",
      value: getDriverName(submittedData.driverId),
    },
    {
      type: "standard",
      id: "shift",
      label: "Shift",
      value: getShiftName(submittedData.shift),
    },
    ...(activeTab === "overview" || activeTab === "all"
      ? [
          {
            type: "standard",
            id: "status",
            label: "Status",
            value: getStatusName(submittedData.status),
          },
        ]
      : []),
  ];

  return (
    <>
      <Popover
        open={filterOpen}
        anchorEl={filterAnchorEl}
        onClose={onCloseFilter}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              boxShadow: "0 10px 30px rgba(15, 23, 42, 0.14)",
              border: "1px solid #E5E7EB",
              width: { xs: "calc(100vw - 32px)", sm: 880 },
              maxWidth: "calc(100vw - 32px)",
            },
          },
        }}
      >
        <Card elevation={0} sx={{ borderRadius: 0 }}>
          <Box p={{ xs: 2, sm: 2.5 }}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              drivers={drivers}
              activeTab={activeTab}
              orderStatuses={orderStatuses}
              shiftModes={shiftModes}
            />
          </Box>
        </Card>
      </Popover>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;
